<!--  -->
<template>
  <div>
      <e-dialog
              dialog-title="石化订单"
              dialogType="other"
              :center-dialog-visible="affirmVisible"
              popup-width="840px"
              :isShowConfirm="false"
              @resetPopupData="onCancel">

          <el-tabs v-model="activeIndex" class="tabs-area" type="card" @tab-click="handleClick">
              <el-tab-pane label="石化采购意向单" name="0"></el-tab-pane>
              <el-tab-pane label="石化采购订单" name="1"></el-tab-pane>
          </el-tabs>

          <tableList
                  class="margin-t20"
                  rowKey="companyId"
                  maxHeight="360"
                  :loading="tableLoading"
                  :table-data="tableData"
                  :table-label="tableLabel">
              <template #handle="{ scope: { row } }">
                  <eui-btn type="text" @click="openDetail(row.id,row.type)">查看详情</eui-btn>
              </template>
          </tableList>
          <!--查看详情-->
          <detail-dialog
                  v-if="viewDetailVisible"
                  :viewDetailVisible.sync="viewDetailVisible"
                  :id="id"
                  :type="type"
          />
      </e-dialog>
  </div>
</template>

<script>
import EDialog from '@/modules/projectA/components/common/e-dialog.vue';
import TableList from '@/modules/projectA/components/common/e-table-list.vue';
import api from '@/modules/projectA/api/order';
import {affirmLabel as oneTableLabel} from '../../common/stockOrder';
import MaterialsDialog from './MaterialsDialog.vue';
import detailDialog from '../../../order/common/detailDialog';

export default {
  components: {
    EDialog,
    TableList,
    MaterialsDialog,
    detailDialog
  },
  props: {
    visible: Boolean,
  },
  data() {
    return {
      viewDetailVisible: false,
      activeIndex: '0',
      id: null,
      type: null,
      total: 0,
      tableLabel: [],
      oneTableLabel,
      twoTableLabel: [
        {label: '订单编号', param: 'orderNo', align: 'center', width: '180'},
        {label: 'ERP订单号', param: 'erpNo', align: 'center', width: '120'},
        {label: '采购商名称', param: 'purchaseCompany', align: 'center', tooltip: true},
        {label: '下单时间', param: 'submitTime', align: 'center', width: '160'},
        {label: '备注', param: 'remark', align: 'center', width: '140', tooltip: true},
        {label: '操作', param: '', align: 'center', slot: 'handle', fixed: 'right'},
      ],
      tableData: [],
      tableLoading: true,
      viewDetailVisible: false,
      listQuery: {
        pageNum: 1,
        pageSize: 10,
      },
      purchasePlanId: -1,
    };
  },
  computed: {
    affirmVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        const {id} = this.$route.params;
        this.listQuery.stockId = id;
        this.listQuery.pageNum = 1;
        setTimeout(() => {
          this.dealSelect();
        }, 500);

      }
    },
  },
  methods: {
    handleClick(val) {
      this.tableLoading = true;
      this.tableLabel = [];
      this.activeIndex = val.index;
      this.dealSelect();
    },
    async dealSelect() {
      if (this.activeIndex === '0') {
        await this.getList(this.listQuery, 'ecQueryStockBind');
        this.tableLabel = this.oneTableLabel;
      } else if (this.activeIndex === '1') {
        await this.getList(this.listQuery, 'pmQueryStockBind');
        this.tableLabel = this.twoTableLabel;
      }
    },
    openDetail(id, type) {
      this.id = id;
      this.type = type;
      this.viewDetailVisible = true;
    },
    onCancel() {
      this.affirmVisible = false;
    },
    async getList(params, methodName) {
      try {
        this.tableLoading = true;
        const {code, data = [], total} = await api[methodName](params);
        if (code === '200') {
          /*  const { records = [], total = 0 } = data; */
          this.tableData = [...data];
          this.tableData.forEach(item => {
            if (this.activeIndex === '0') {
              this.$set(item, 'type', 1)
            } else {
              this.$set(item, 'type', 2)
            }
          })
          this.total = this.tableData.length;
          this.tableLoading = false;
        }
      } catch (error) {
        console.error(error);
        // this.tableData = [];
      } finally {
        this.tableLoading = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-radio__label {
  display: none;
}
</style>
